import { Box, Typography } from "@mui/material"
import { CheckOutlined, CloseOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface ColumnContentProps {
  content?: string | string[] | boolean | null
  children?: string
}

export const ColumnContent: FC<ColumnContentProps> = ({ content, children }) => {
  if (Array.isArray(content)) {
    return (
      <Box gap={1} className='flex flex-col'>
        {content.length === 0 && (
          <Typography variant='body2' className='text-gray-700'>
            -
          </Typography>
        )}
        {content.map((item, index) => (
          <Typography key={`${item}-${index}`} variant='body2' className='text-gray-700'>
            {item}
          </Typography>
        ))}
      </Box>
    )
  }

  return (
    <Box gap={1.5} className='flex items-center'>
      {content ? <CheckOutlined className='text-green-700' /> : <CloseOutlined className='text-secondary-600' />}
      <Typography variant='body2' className='text-gray-700'>
        {children || String(content)}
      </Typography>
    </Box>
  )
}
